module.exports = __webpack_public_path__ + "img/Alevizos.09d6dd74.jpg";